import { call, fork, put, take } from 'redux-saga/effects'
import fetchApi from '../../../../../utils/fetchApi'

function* getGroupFlow() {
  const INFINITE = true

  while (INFINITE) {
    const {
      payload: { id },
      next
    } = yield take('GET_GLASSES_GROUP_DETAIL')

    yield put({ type: 'CLEAR_GLASSES_STATE' })

    try {
      const response = yield call(fetchApi, `Groups/${id}`)

      if (response && !response.error) {
        yield put({
          type: 'GET_GLASSES_GROUP_SUCCESS',
          payload: response
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* editGroupFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload } = yield take('EDIT_GLASSES_GROUP')
    try {
      const values = {
        ...(payload.filter && { filter: payload.filter }),
        ...(payload.name && { name: payload.name }),
        ...(payload.status && { status: payload.status })
      }
      yield call(fetchApi, `Groups/${payload.groupId}`, values, { method: 'PATCH' })
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

function* createGroupFlow() {
  const INFINITE = true

  while (INFINITE) {
    const { payload, next } = yield take('CREATE_GLASSES_GROUP')
    try {
      const group = yield call(fetchApi, `Groups`, payload, { method: 'POST' })

      if (group && !group.error) {
        yield put({
          type: 'CREATE_GLASSES_GROUP_SUCCESS',
          payload: group
        })
        if (next && typeof next === 'function') {
          next()
        }
      }
    } catch (err) {
      yield put({ type: 'REQUEST_ERROR', payload: err })
    }
  }
}

export default function* groupGlassesDetailFlow() {
  yield fork(getGroupFlow)
  yield fork(editGroupFlow)
  yield fork(createGroupFlow)
}



// WEBPACK FOOTER //
// ./routes/app/routes/glasses-group-detail/saga/index.js